import { CloseOutlined } from '@ant-design/icons';
import { t } from '@lingui/macro';
import { message } from 'antd';
import React from 'react';
import { css } from 'styled-components';

export const ExpiredMessageStyled = css`
    .session-expired-msg {
        .msg-icon--right {
            margin-left: 6px;
            font-size: 15px;
            color: rgba(0, 0, 0, 55%);
            transition: color 200ms ease;

            &:hover {
                color: rgba(0, 0, 0) !important;
            }
        }
    }
`;
export class SessionExpiredMessage {
    MESSAGE_KEY_EXPIRED_SESSION = 'expired-session';
    msgConfig = {
        className: 'session-expired-msg',
        key: this.MESSAGE_KEY_EXPIRED_SESSION,
        content: (
            <span>
                {t`Your session has expired. Please log in again.`}
                <CloseOutlined
                    className="msg-icon--right"
                    onClick={() => message.destroy(this.MESSAGE_KEY_EXPIRED_SESSION)}
                />
            </span>
        ),
        duration: 0,
    };

    destroy() {
        message.destroy(this.MESSAGE_KEY_EXPIRED_SESSION);
    }

    show() {
        message.warning(this.msgConfig);
    }
}
